import styled from 'styles/styled';

export const Trade = styled.div`
  background: #15191E;
  border-radius: 10px;
  padding: 12px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0;

  @media (max-width: 720px) {
    padding: 10px 12px 12px;
  }
`;

export const SideTabs = styled.div`
  position: relative;
  background: #292B2E;
  height: 36px;
  border-radius: 10px;
  display: flex;
  overflow: hidden;
  margin-bottom: 10px;
`;

export const SideTab = styled.button`
  flex: 1;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: #7A7E8C;
  font-weight: 600;
  font-size: 13px;
  font-family: inherit;
  transition: color 200ms ease-in, background 200ms ease-in;

  &.long.on {
    background: #52D381;
    color: #0A0A0A;
    border-radius: 10px;
  }

  &.short.on {
    background: #FF6782;
    color: #0A0A0A;
    border-radius: 10px;
  }
`;

export const ModeTabs = styled.div`
  display: flex;
  gap: 14px;
  border-bottom: 1px solid #2A2E34;
  margin-bottom: 10px;
`;

export const ModeTab = styled.button`
  background: transparent;
  border: 0;
  cursor: pointer;
  color: #7A7E8C;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  padding: 6px 0;
  border-bottom: 2px solid transparent;
  transition: color 200ms, border-color 200ms;

  &.on {
    color: #EFEFEF;
    border-color: #52D381;
    font-weight: 700;
  }
`;

export const LevRow = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
`;

export const LevChip = styled.button<{ $shortSide?: boolean }>`
  flex: 1;
  background: #292B2E;
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 6px 0;
  font-size: 11px;
  color: #7A7E8C;
  cursor: pointer;
  font-weight: 500;
  font-family: inherit;
  transition: background 120ms ease, color 120ms ease, border-color 120ms ease;

  &:hover {
    color: #EFEFEF;
  }

  &.on {
    background: transparent;
    color: #EFEFEF;
    font-weight: 700;
    border-color: ${(p) => (p.$shortSide ? '#FF6782' : '#52D381')};
  }
`;

export const Field = styled.div`
  background: #292B2E;
  border-radius: 10px;
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  .l {
    font-size: 11px;
    color: #7A7E8C;
    flex-shrink: 0;
  }

  .v {
    background: transparent;
    border: 0;
    color: #EFEFEF;
    font-size: 16px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    outline: none;
    text-align: right;
    width: 60%;
    font-family: inherit;
    padding: 0;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .u {
    color: #A7A8B2;
    font-size: 12px;
    font-weight: 500;
    margin-left: 8px;
    flex-shrink: 0;
  }
`;

export const Pcts = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
`;

export const PctBtn = styled.button`
  flex: 1;
  background: #292B2E;
  border: 0;
  border-radius: 6px;
  padding: 6px;
  font-size: 11px;
  color: #7A7E8C;
  cursor: pointer;
  font-family: inherit;
  font-weight: 500;
  transition: background 120ms ease, color 120ms ease;

  &:hover {
    color: #EFEFEF;
    background: #1B1F25;
  }
`;

export const Meta = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #7A7E8C;
  margin-bottom: 8px;

  b {
    color: #EFEFEF;
    font-weight: 700;
    font-variant-numeric: tabular-nums;

    &.tb-pos {
      color: #52D381;
    }

    &.tb-neg {
      color: #FF6782;
    }
  }
`;

export const CTA = styled.button<{ $side?: 'long' | 'short' }>`
  width: 100%;
  height: 46px;
  border: 0;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  color: #0A0A0A;
  cursor: pointer;
  transition: opacity 200ms;
  font-family: inherit;
  background: ${(p) => (p.$side === 'short' ? '#FF6782' : '#52D381')};

  &:hover:not(:disabled) {
    opacity: 0.92;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TpslButton = styled.button`
  background: #292B2E;
  border: 0;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  font-family: inherit;
  width: 100%;

  &:hover {
    background: #1B1F25;
  }

  .l {
    font-size: 12px;
    color: #A7A8B2;
    font-weight: 500;
  }

  .v {
    color: #EFEFEF;
    font-size: 13px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }

  .chev {
    color: #7A7E8C;
    margin-left: 6px;
  }
`;

export const ErrorBanner = styled.div`
  background: rgba(255, 103, 130, 0.1);
  border: 1px solid rgba(255, 103, 130, 0.3);
  color: #FF6782;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 8px;
  line-height: 1.4;
`;

export const TpslOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const TpslModal = styled.div`
  background: #15191E;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 360px;
  position: relative;
`;

export const TpslClose = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7A7E8C;
  background: transparent;
  border: 0;
  padding: 0;
  font-family: inherit;

  &::before {
    content: '×';
    font-size: 24px;
    line-height: 1;
  }

  &:hover {
    color: #EFEFEF;
  }
`;
